import { useEffect, useCallback } from 'react';
import { wsManager } from '../services/websocket';

export function useWebSocket(onMessage?: (type: string, data: any) => void) {
  const token = localStorage.getItem('jwt');

  useEffect(() => {
    if (!token) return;

    if (onMessage) {
      // Listen to all relevant types
      wsManager.on('telemetry', (data) => onMessage('telemetry', data));
      wsManager.on('connected', (data) => onMessage('connected', data));
      wsManager.on('error', (data) => onMessage('error', data));
    }
  }, [token, onMessage]);

  const subscribe = useCallback((imeis: string[]) => {
    wsManager.send('subscribe', { imeis });
  }, []);

  return { subscribe };
}
